'use client';

import { MarketId } from '@velocity-exchange/common';
import useVelocityStore from '../stores/VelocityStore/useVelocityStore';

const useBorrowLendDataForMarket = (market: MarketId) => {
	if (!market.isSpot) {
		throw 'Must use a SPOT market in useBorrowLendDataForMarket';
	}

	const borrowLendData = useVelocityStore((s) => s.borrowLendData);

	const targetMarketBorrowLendData = borrowLendData.find(
		(borrowLend) => borrowLend.bankConfig.marketIndex === market.marketIndex
	);

	return targetMarketBorrowLendData;
};

export default useBorrowLendDataForMarket;
